import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import PropTypes from 'prop-types';
import { bind, equal, isNil, isNullOrWhitespace } from 'vdlib';
import LookupsHelper from 'lib/LookupsHelper';

import { Card, Descriptions } from 'antd';
import { ToolOutlined } from '@ant-design/icons';

const descriptionDetailsStyle = {
  fontSize: 16,
  fontWeight: 600,
};

class AuctionGarageData extends React.Component {
  constructor(props) {
    super(props);
    bind(this, ['populate']);
    this.populate(props);
  }

  componentWillReceiveProps(nextProps) {
    if (!equal(this.props, nextProps)) this.populate(nextProps);
  }

  populate(props) {
    if (isNil(props)) props = this.props;

    if (isNil(props.garageData)) return;

    this.title = props.garageData.DistinctiveTitle;
    this.address = `${props.garageData.Street} ${props.garageData.StreetNumber}, ${props.garageData.PostalCode}`;
    this.contact = (
      <div>
        {props.garageData.Phone}
        {isNullOrWhitespace(props.garageData.Fax)
          ? ''
          : ' - ' + props.garageData.Fax}
        <br />
        {props.garageData.Email}
      </div>
    );
  }

  render() {
    if (isNil(this.props.data)) return false;

    return (
      <Card
        headStyle={{ background: '#f7ebbb' }}
        title={
          <div>
            <span>
              <ToolOutlined
                style={{
                  fontSize: 22,
                  color: '#6d6d6d',
                  verticalAlign: '0em',
                  marginRight: 5,
                }}
              />
            </span>
            <span style={{ fontSize: 18, fontWeight: 600, color: '#6d6d6d' }}>
              {`${I.t('GARAGE_C')}: ${this.props.data.DistinctiveTitle}`}
            </span>
          </div>
        }
      >
        <Descriptions
          className="profile"
          colon={false}
          column={1}
          size="small"
          bordered
        >
          <Descriptions.Item label={I.t('TAXNUMBER')}>
            <span style={descriptionDetailsStyle}>{this.props.data.AFM}</span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('TAXOFFICE')}>
            <span style={descriptionDetailsStyle}>
              {' '}
              {LookupsHelper.getDescription(
                this.props.taxOffices,
                this.props.data.TaxOfficeID
              )}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('ADDRESS')}>
            <span style={descriptionDetailsStyle}>
              {`${this.props.data.Street} ${this.props.data.StreetNumber}, ${this.props.data.PostalCode}, ${this.props.data.City} `}{' '}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('PHONE_SHORT')}>
            <span style={descriptionDetailsStyle}>{`${
              this.props.data.Phone || '-'
            } `}</span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('FAX')}>
            <span style={descriptionDetailsStyle}>{`${
              this.props.data.Fax || '-'
            } `}</span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('MOBILE')}>
            <span style={descriptionDetailsStyle}>{`${
              this.props.data.Mobile || '-'
            } `}</span>
          </Descriptions.Item>
        </Descriptions>
      </Card>
    );
  }
}

AuctionGarageData.propTypes = {
  data: PropTypes.object,
  taxOffices: PropTypes.object,
  loading: PropTypes.bool,
};

export default AuctionGarageData;
